if($('.type-detail').length){
    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="kosik"></div>')
    $('.link-icons').prepend('<span class="btn_toggle">Přidat do oblíbených</span>')
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'))
    if($('.variant-list').length>0){
        $('.variant-list select').each(function(){
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if ($.isNumeric($(this).val())) {
                    html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    html_var += '<div class="text">'+$(this).text()+'</div>'
                    html_var += '</div>'
                }
            })
            html_var += '</div></div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
           $(this).closest('.variant-list span').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
            }
        }
        
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value')
        const variantParameterId = $(this).data('parameter-id')
        $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
        $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
        $(this).addClass("active");    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value')
            const variantParameterId = $(this).data('parameter-id')
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"']  option[value='" + variantData + "']").hasClass("unavailable-option")    
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active")
            }
            else{
                $(this).removeClass("unavailable")
            } 
        })
        
       
    })

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
              $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
}